import { Component } from "react";
import { connect } from "react-redux";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { updateFilters } from "../../redux/siteMonitoring/siteMonitoringActions";
import TextFieldWithTypingTimeout from "../Input/TextFieldWithTypingTimeout";
import Checkbox from "@mui/material/Checkbox";
import { ALL_SELECT_OPTION } from "../../constants";
import { clone, distinct } from "../../utils";
import "./SiteMonitoringListFilters.css";
import { formatStatus } from "../../redux/siteMonitoring/siteMonitoringStatusActions";
import { FormControl, InputLabel, MenuItem } from "@mui/material";
import CustomizedSelect from "../Input/CustomizedSelect";

class SiteMonitoringListFilters extends Component {
	state = {
		requireAction: this.props.siteMonitoringListFilters.requireAction,
	};

	updateSiteNumber(value) {
		let newFilters = clone(this.props.siteMonitoringListFilters);
		newFilters.siteNumber = value;
		this.props.updateFilters(newFilters, this.props.siteMonitorings, this.props.activeUser.id);
	}

	updateCity(value) {
		let newFilters = clone(this.props.siteMonitoringListFilters);
		newFilters.city = value;
		this.props.updateFilters(newFilters, this.props.siteMonitorings, this.props.activeUser.id);
	}

	updateCustomer(value) {
		let newFilters = clone(this.props.siteMonitoringListFilters);
		newFilters.customer = value;
		this.props.updateFilters(newFilters, this.props.siteMonitorings, this.props.activeUser.id);
	}

	onStatesChange(e) {
		let newFilters = clone(this.props.siteMonitoringListFilters);
		newFilters.status = e.target.value;
		this.props.updateFilters(newFilters, this.props.siteMonitorings, this.props.activeUser.id);
	}

	onRequireActionChange(e, value) {
		let newFilters = clone(this.props.siteMonitoringListFilters);
		newFilters.requireAction = value;
		this.props.updateFilters(newFilters, this.props.siteMonitorings, this.props.activeUser.id);
	}

	render() {
		let allElement = (
			<MenuItem key={0} value={ALL_SELECT_OPTION}>
				{"Tous"}
			</MenuItem>
		);

		let stateElements = [allElement];

		this.props.siteMonitorings
			.map((n) => n.state)
			.filter(distinct)
			.map((state, index) =>
				stateElements.push(
					<MenuItem key={index} value={state}>
						{formatStatus(state)}
					</MenuItem>
				)
			);

		return (
			<Card className={"card col-lg-12 col-md-12 col-sm-12 col-12 without-side-margin filters-card"}>
				<CardContent className={"col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding"}>
					<div className="col-lg-3 col-md-6 col-sm-6 col-12">
						<TextFieldWithTypingTimeout
							id="number"
							label={"Numéro de chantier"}
							className="full_size"
							value={this.props.siteMonitoringListFilters.siteNumber}
							onValueChange={this.updateSiteNumber.bind(this)}
						/>
					</div>
					<div className="col-lg-3 col-md-6 col-sm-6 col-12">
						<TextFieldWithTypingTimeout
							id="city"
							label={"Ville"}
							className="full_size"
							value={this.props.siteMonitoringListFilters.city}
							onValueChange={this.updateCity.bind(this)}
						/>
					</div>
					<div className="col-lg-3 col-md-6 col-sm-6 col-12">
						<TextFieldWithTypingTimeout
							id="customer"
							label={"Client"}
							className="full_size"
							value={this.props.siteMonitoringListFilters.customer}
							onValueChange={this.updateCustomer.bind(this)}
						/>
					</div>
					<div className="col-lg-3 col-md-6 col-sm-6 col-12">
						<FormControl className="col-lg-12 col-md-12 col-sm-12 col-12 ">
							<InputLabel id="state-label">Statut</InputLabel>
							<CustomizedSelect
								labelId="state-label"
								id="state"
								name="state"
								label="Statut"
								value={this.props.siteMonitoringListFilters.status}
								onChange={this.onStatesChange.bind(this)}
								multiple
							>
								{stateElements}
							</CustomizedSelect>
						</FormControl>
					</div>
					<div className="row col-lg-3 col-md-6 col-sm-6 col-12 without-side-padding site-monitoring-checkbox-margin">
						<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-padding">
							<Checkbox
								label={"Avec action demandée"}
								checked={this.props.siteMonitoringListFilters.requireAction}
								onChange={this.onRequireActionChange.bind(this)}
								className="small-checkbox "
							/>
						</div>
						<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-padding label-ellipsis">
							<span>Avec action demandée</span>
						</div>
					</div>
				</CardContent>
			</Card>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		activeUser: state.activeUser,
		siteMonitoringListFilters: state.siteMonitorings.siteMonitoringsFilters,
		siteMonitorings: state.siteMonitorings.siteMonitorings,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateFilters: (filters, siteMonitorings, userId) => dispatch(updateFilters(filters, siteMonitorings, userId)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SiteMonitoringListFilters);
